// src/components/LoadingScreen.js
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function LoadingScreen({ onLoadingComplete }) {
  const [isVisible, setIsVisible] = useState(true);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    const textTimer = setTimeout(() => setShowText(true), 2600);

    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onLoadingComplete?.(), 1100);
    }, 4000);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(hideTimer);
    };
  }, [onLoadingComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ x: '-100vw' }}
          animate={{ x: 0 }}
          exit={{ opacity: 0 }}
          transition={{
            x: {
              duration: 2.4,
              ease: [0.2, 0, 0.1, 1],
            },
            opacity: { duration: 1.0, ease: 'easeInOut' },
          }}
          style={{
            position: 'fixed',
            inset: 0,
            background: '#000000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 2.0,
              ease: 'easeOut',
              delay: 0.6,
            }}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2rem',
            }}
          >
            <img
              src="/SSDLogo.svg"
              alt="Start Something Different Logo"
              style={{
                width: '700px',
                maxWidth: '85vw',
                height: 'auto',
              }}
            />

            {/* Responsive subtitle – smaller on mobile */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: showText ? 1 : 0, y: showText ? 0 : 20 }}
              transition={{ duration: 1.4, ease: 'easeOut' }}
              style={{
                margin: 0,
                fontFamily: "'Manrope', sans-serif",
                fontSize: 'clamp(0.75rem, 2.5vw + 0.2rem, 1.1rem)', // Perfectly responsive
                fontWeight: 300,
                color: '#ffffff',
                textAlign: 'center',
                letterSpacing: '0.8px',
                lineHeight: 1.4,
              }}
            >
              Europe, Middle East, North America & Asia Pacific
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}